'use strict';

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _util = require('../util');

var HashHistory = (function () {
  function HashHistory(_ref) {
    var hashbang = _ref.hashbang;
    var onChange = _ref.onChange;

    _classCallCheck(this, HashHistory);

    this.hashbang = hashbang;
    this.onChange = onChange;
  }

  _createClass(HashHistory, [{
    key: 'start',
    value: function start() {
      var self = this;
      this.listener = function () {
        var path = location.hash;
        var formattedPath = self.formatPath(path, true);
        if (formattedPath !== path) {
          location.replace(formattedPath);
          return;
        }
        var pathToMatch = decodeURI(path.replace(/^#!?/, '') + location.search);
        self.onChange(pathToMatch);
      };
      window.addEventListener('hashchange', this.listener);
      this.listener();
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.removeEventListener('hashchange', this.listener);
    }
  }, {
    key: 'go',
    value: function go(path, replace) {
      path = this.formatPath(path);
      if (replace) {
        location.replace(path);
      } else {
        location.hash = path;
      }
    }
  }, {
    key: 'formatPath',
    value: function formatPath(path, expectAbsolute) {
      path = path.replace(/^#!?/, '');
      var isAbsoloute = path.charAt(0) === '/';
      if (expectAbsolute && !isAbsoloute) {
        path = '/' + path;
      }
      var prefix = '#' + (this.hashbang ? '!' : '');
      return isAbsoloute || expectAbsolute ? prefix + path : prefix + (0, _util.resolvePath)(location.hash.replace(/^#!?/, ''), path);
    }
  }]);

  return HashHistory;
})();

exports['default'] = HashHistory;
module.exports = exports['default'];